module.exports = __webpack_public_path__ + "static/media/rob.6014b305.png";